export default {
    import_account_label: 'Cuenta',
    import_account_imported_on: 'Importado el',
    import_account_updated_on: 'Actualizado el',
    import_account_contacts: 'Contactos',
    import_account_alerts: 'Alertas',
    import_account_categories: 'Categorias',
    import_account_behavior: 'Comportamiento',
    import_account_users: 'Usuarios',
    import_account_drivers: 'Conductores',
    import_account_devices: 'Dispositivos',
    import_account_geofences: 'Geocercas',
    import_account_maintenance: 'Mantenimiento',
    import_account_exceptions: 'Excepciones',
    import_account_title: 'Importar P4',
    import_account_import_account: 'Importar cuenta',
    import_account_external_id: 'Id. externo',
    import_account_speed_override: 'Anulación de velocidad',
};